import React from "react";

const Error = () => {
  const center = {};
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        fontSize: "2rem",
      }}
    >
      {" "}
      Invalid Routes !!
    </div>
  );
};

export default Error;
